import React from 'react';
import { DataCard } from 'anf-core-react';
import { shippingAddressCardProps } from './props';
import { TmntText, ShippingAddress } from '../Common';

export default function ShippingAddressCard({ shippingAddress }) {
  const { title, shippedToAddress } = shippingAddress;
  const { mapUrl } = shippedToAddress;

  return (
    <div className="shipping-address-card" data-testid="shipping-address-card">
      <DataCard
        headerTitle={title?.value}
        variant="boxed"
      >
        <ShippingAddress className="shipping-address" shippingAddress={shippedToAddress} />
      </DataCard>
      {mapUrl && mapUrl.value && (
        <a href={mapUrl.value} target="_blank" className="direction-link" rel="noreferrer">
          <TmntText tmnt={mapUrl.label} />
        </a>
      )}
    </div>
  );
}

ShippingAddressCard.propTypes = shippingAddressCardProps;
